// @ts-nocheck

/**
 * TAMIX SAAS PLATFORM - Dashboard Component
 * =========================================
 * Generated: 2025-09-22 - Session 6 Sprint 0
 * Main dashboard with role-based content
 */

import { tenantApi } from '@/services/tenantApi'
import { useAuthStore } from '@/store/authStore'
import React from 'react'
import { useQuery } from 'react-query'

const Dashboard: React.FC = () => {
  const { user } = useAuthStore()

  // Load tenant stats for platform admin
  const { data: tenantStats } = useQuery(
    'tenant-stats',
    () => tenantApi.getTenantStats(),
    {
      enabled: user?.role === 'platform_admin'
    }
  )

  const renderPlatformAdminDashboard = () => (
    <>
      {/* Stats Cards */}
      <div className="dashboard-grid mb-4">
        <div className="card">
          <div className="card-body">
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h6 className="card-title text-muted mb-1">Total Tenants</h6>
                <h3 className="mb-0">{tenantStats?.total_tenants || 0}</h3>
              </div>
              <div className="bg-primary text-white rounded p-3">
                <i className="fas fa-building fa-2x"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h6 className="card-title text-muted mb-1">Tenants Activos</h6>
                <h3 className="mb-0">{tenantStats?.active_tenants || 0}</h3>
              </div>
              <div className="bg-success text-white rounded p-3">
                <i className="fas fa-check-circle fa-2x"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h6 className="card-title text-muted mb-1">Total Usuarios</h6>
                <h3 className="mb-0">{tenantStats?.total_users || 0}</h3>
              </div>
              <div className="bg-info text-white rounded p-3">
                <i className="fas fa-users fa-2x"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h6 className="card-title text-muted mb-1">Crecimiento</h6>
                <h3 className="mb-0">+{tenantStats?.growth_rate || 0}%</h3>
              </div>
              <div className="bg-warning text-white rounded p-3">
                <i className="fas fa-chart-line fa-2x"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="row">
        <div className="col-md-8">
          <div className="card">
            <div className="card-header">
              <h6 className="mb-0">Acciones Rápidas</h6>
            </div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <a href="/tenants" className="btn btn-outline-primary w-100">
                    <i className="fas fa-building me-2"></i>
                    Gestionar Tenants
                  </a>
                </div>
                <div className="col-md-6">
                  <a href="/tenants/new" className="btn btn-outline-success w-100">
                    <i className="fas fa-plus me-2"></i>
                    Nuevo Tenant
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card">
            <div className="card-header">
              <h6 className="mb-0">Sistema</h6>
            </div>
            <div className="card-body">
              <div className="d-flex align-items-center mb-2">
                <span className="badge bg-success me-2">●</span>
                API Backend
              </div>
              <div className="d-flex align-items-center mb-2">
                <span className="badge bg-success me-2">●</span>
                Base de Datos
              </div>
              <div className="d-flex align-items-center">
                <span className="badge bg-success me-2">●</span>
                Autenticación
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )

  const renderTenantDashboard = () => (
    <>
      <div className="alert alert-info">
        <h4>¡Bienvenido a TAMIX!</h4>
        <p>
          Tu dashboard personalizado para la gestión de evaluaciones psicosociales
          estará disponible próximamente.
        </p>
      </div>

      <div className="card">
        <div className="card-body text-center py-5">
          <i className="fas fa-clipboard-check fa-4x text-muted mb-4"></i>
          <h4>Evaluaciones NOM-035</h4>
          <p className="text-muted">
            Próximamente: Sistema completo de evaluación psicosocial
          </p>
          <button className="btn btn-primary" disabled>
            Próximamente
          </button>
        </div>
      </div>
    </>
  )

  const renderStaffDashboard = () => (
    <div className="card mt-4 shadow-sm">
      <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
        <h6 className="mb-0">Psicometría Avanzada: Índice de Hesitación (CU-001)</h6>
        <span className="badge bg-success">En Vivo</span>
      </div>
      <div className="card-body">
        <div className="row g-4">
          <div className="col-md-4">
            <div className="text-center p-4 border rounded bg-light">
              <h2 className="text-primary mb-1">42ms</h2>
              <p className="text-muted small mb-0">First Interaction Delta (Promedio)</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="text-center p-4 border rounded bg-light">
              <h2 className="text-warning mb-1">3.2</h2>
              <p className="text-muted small mb-0">Hovers por Ítem</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="text-center p-4 border rounded bg-light border-warning">
              <h2 className="text-danger mb-1">64%</h2>
              <p className="text-muted small mb-0">Índice de Hesitación (Global)</p>
            </div>
          </div>
        </div>
        <div className="mt-4">
          <h6 className="text-muted mb-3">Alertas de Comportamiento</h6>
          <div className="alert alert-info py-2 small">
            <i className="fas fa-info-circle me-2"></i>
            Detección de patrones de duda elevada en la competencia: "Liderazgo Estratégico".
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <div>
      {/* Welcome Header */}
      <div className="mb-4">
        <h1 className="h2 mb-1">
          ¡Hola, {user?.name}!
        </h1>
        <p className="text-muted">
          Bienvenido a tu dashboard de TAMIX - Plataforma de Evaluación Psicosocial
        </p>
        {user?.tenant && (
          <div className="badge bg-light text-dark">
            <i className="fas fa-building me-1"></i>
            {user.tenant.name}
          </div>
        )}
      </div>

      {/* Role-based Dashboard Content */}
      {user?.role === 'platform_admin'
        ? renderPlatformAdminDashboard()
        : user?.role === 'staff'
          ? renderStaffDashboard()
          : renderTenantDashboard()
      }
    </div>
  )
}

export default Dashboard
